import React from "react";

type Props = { text: string };

export const Title: React.FC<Props> = ({ text }) => {
  return (
    <div className="columns is-vcentered">
      <div className="column has-text-left">
        <h1 className="title">{text}</h1>
      </div>
    </div>
  );
};

export default Title;
